import {combineReducers} from 'redux';
import authReducer from './authReducer';
import policyReducer from './policyReducer';
import loaderReducer from './loaderReducer';


const rootReducer = combineReducers({
    Auth: authReducer,
    Policy: policyReducer,
    Loader: loaderReducer,
})

export default rootReducer;